export default __webpack_public_path__ + "assets/icon-schedule-cyan.7d345f26.webp";